import React, { PureComponent } from 'react';
import DropboxChooser from 'react-dropbox-chooser';

import config from '../config';
import { externalLoad } from '../api/files-api';
import { createAlert } from '../services/alert-service';

export default class DropboxFileChooser extends PureComponent {
    handleSuccess = files => {
        if (this.props.onChange) {
            this.props.onChange(files.map(file => ({
                ...file,
                serviceType: 'dropbox',
                serviceProps: {
                    type: 'dropbox',
                    link: file.link,
                    name: file.name,
                    size: file.bytes
                }
            })));
            return;
        }

        let alertText;

        if (files.length === 1) {
            alertText = `<i class="icon material-icons icon-animate-rotate">autorenew</i> Importing ${files[0].name}...`;
        } else {
            alertText = `<i class="icon material-icons icon-animate-rotate">autorenew</i> Importing ${files.length} files...`;
        }

        const alert = createAlert('success', alertText, {
            duration: 0
        });

        externalLoad({
            project: this.props.projectId,
            task: this.props.taskId,
            doc: this.props.docId,
            files: files.map(({ link, name, bytes: size }) => ({
                type: 'dropbox',
                link,
                name,
                size
            }))
        }).then(response => {
            alert.setContent(`<i class="icon material-icons">check_circle</i> Your ${(files.length > 1 ? 'files were' : 'file was')} successfully imported.`);
            alert.hide(5000);
        });
    }

    render() {
        return (
            <DropboxChooser 
                appKey={config.DROPBOX.APP_KEY}
                success={this.handleSuccess}
                linkType="direct"
                multiselect={true}
            >
                {this.props.children}
            </DropboxChooser>
        )
    }
}
